const STORAGE_KEY_PREFIX = 'snovasys_usage_analytics_session_';

/**
 * Generate a UUID v4 (uses crypto.randomUUID when available, else fallback).
 */
export function generateId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return fallbackUuidV4();
}

function fallbackUuidV4(): string {
  const hex = '0123456789abcdef';
  let result = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  result = result.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return hex[v];
  });
  return result;
}

/**
 * Get or create session id. Optionally persist in sessionStorage keyed by appId.
 */
export function getOrCreateSessionId(appId: string, providedSessionId?: string): string {
  if (providedSessionId) return providedSessionId;
  const key = `${STORAGE_KEY_PREFIX}${appId}`;
  if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
    try {
      const existing = sessionStorage.getItem(key);
      if (existing) return existing;
      const newId = generateId();
      sessionStorage.setItem(key, newId);
      return newId;
    } catch {
      return generateId();
    }
  }
  return generateId();
}
